import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { FAQ } from '@banyan/commons/models/faq.model';
import { FAQService } from '@banyan/modules/faq/services/faq.service';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';
import { ExpansionPanelComponent } from '@banyan/modules/standalone/expansion-panel/expansion-panel.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-expansion-panel-mobile',
  templateUrl: './expansion-panel-mobile.component.html',
  styleUrls: ['./expansion-panel-mobile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ExpansionPanelComponent,
    MatExpansionModule,
    ButtonComponent,
  ],
})
export class ExpansionPanelMobileComponent {
  @Input() question: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() isChecked: boolean = false;
  @Input() defaultChecked: boolean = false;
  @Output() checkedEvent = new EventEmitter<boolean>();
  panelOpenState: boolean = false;
  openQuestion: FAQ = {
    id: '',
    question: '',
    answer: '',
    category: '',
  };
  faqService = inject(FAQService);

  openPanel(question: FAQ): void {
    this.openQuestion = question;
  }

  onChange(event: any) {
    if (!this.defaultChecked) {
      this.isChecked = !this.isChecked;
    }
    this.checkedEvent.emit(event.checked);
  }
}
